import React, { useEffect, useState } from "react";
import withAppState from '../mobx/withAppState';
import { Steps } from '../lib/constants';
import dataLayer from '../lib/dataLayer';
import deliveryMan from '../assets/img/deliveryMan.svg';

const {dataLayerAttribute} = dataLayer; 
const {addToDataLayerList} = dataLayer;

const MenuFooterLinks = props => {

    const { activeStep, restaurant, restaurantUrl } = props;
    const [footerMenuData, setFooterMenuData] = useState([]);

    useEffect(() => {
        let isMounted = true;
        async function fetchAPI() {
            try {
                const response = await fetch(`api/Menu/FooterMenu`);
                if (response.status === 200 && isMounted) {
                    const data = await response.json();
                    if (isMounted) {
                        setFooterMenuData(data);
                    }
                }
            } catch (error) {
                // Handle error if needed
            }
        }

        fetchAPI();
    }, []);  

    let bookATableUrl = '';
    let menuType = null;

    if (footerMenuData?.bookings?.find(md => md.name === "Book A Table")) {
        bookATableUrl = footerMenuData.bookings.filter(md => md.name === "Book A Table")[0].url;
    }
    if (!!restaurant?.restaurantUrlName && activeStep === Steps.PRE_ORDER) { //at the point when the user chooses or changes the restaurant
        bookATableUrl = bookATableUrl + `${restaurant.restaurantUrlName}/book/book-a-table`;
        menuType = "local menu";
    }
    else if (!!restaurantUrl) { //at the point when the digital menu loads from a local restaurant page in the milano main site
        bookATableUrl = bookATableUrl + `${restaurant.restaurantUrlName}/book/book-a-table`;
        menuType = "local menu";
    }
    else { //at the point when the global menu loads.
        bookATableUrl = bookATableUrl + "/book/book-a-table-uk";
        menuType = "global menu";
    }

    const handleBookClick = (e) => {
    
        var dataLayerArray = [];
    
        if (menuType === "local menu") {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "book_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "book_link_clicked_footer" },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
            );
        }
        else {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "book_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "book_link_clicked_footer" },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
            );
        }
    
        addToDataLayerList(dataLayerArray);
    }
    
    const handleOrderClick =(e) => {
    
        var dataLayerArray = [];
    
        if (menuType === "local menu") {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "order_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "order_link_clicked_footer" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
            );
        }
        else {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "order_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "order_link_clicked_footer" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType }
            );
        }
    
    addToDataLayerList(dataLayerArray);
    }
    
    const handleDeliveryClick = (e) => {
    
        var dataLayerArray = [];
    
        if (menuType === "local menu") {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "delivery_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "delivery_link_clicked_footer" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
            );
        }
        else {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "delivery_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "delivery_link_clicked_footer" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
            );
        }
    
        addToDataLayerList(dataLayerArray);
    }

    return (
        <div>
            <div className="">
                <div className="section-padding-xtrathin">
                    <div className="is-social-row row-wrap-mobile">
                        <div className="is-col icon-link">
                            <a href="https://twitter.com/milano_ireland"><img src="https://www.milano.ie/-/media/Milano/2024-Images/Mar/X_logo.ashx?h=150&la=en&w=150&hash=2E2A06545F33126F55AAE094D890D75A" alt="x" className="social-icon icon is-medium"></img></a>
                        </div>
                        <div className="is-col icon-link">
                            <a href="https://www.facebook.com/MilanoIreland"><img src="https://www.milano.ie/-/media/2022-Images/rebrand_2022/facebook.ashx?h=32&la=en&w=32&hash=5ACBA7E6A452FC6FE6D25337FB46E9F8" alt="facebook" className="social-icon icon is-medium"></img></a>
                        </div>
                        <div className="is-col icon-link">
                            <a href="https://www.instagram.com/milanoireland/"><img src="https://www.milano.ie/-/media/2022-Images/rebrand_2022/instagram.ashx?h=32&la=en&w=32&hash=0143BDE3B2CE79C4340672D5EAFE1489" alt="instagram" className="social-icon icon is-medium"></img></a>
                        </div>
                    </div>
                    {/*<div className="deliveryMan hide-mobile">*/}
                    {/*    <img src={deliveryMan} />                       */}
                    {/*</div>*/}
                </div>
            </div>
            <div class="is-col section-padding-thin no-padding-top">
                <hr></hr>
            </div>
            <div className="menu-footer-section">
                <div className="is-col is-3-col is-12-col-mobile is-12-col-tablet footer-links txt-white">
                    <h5>Food</h5>
                    {footerMenuData?.food?.map(item => <a href={item.name === "Our Menu" ? window.location.href : item.url}
                        className="is-row"
                        title={item.name}
                        onClick={item.name === "Collection" ? handleOrderClick : item.name === "Delivery" ? handleDeliveryClick : ""}
                        target={item.name === "Cook at Home" || item.name === "Allergens & Nutritionals" ? "_blank" : "_self"}
                    >{item.name}</a>
                    )}
                </div>
                <div className="is-col is-3-col is-12-col-mobile is-12-col-tablet footer-links txt-white">
                    <h5>Bookings</h5>
                    {footerMenuData?.bookings?.map(item =>
                        <a href={item.name === "Book A Table" ? bookATableUrl : item.url} onClick={item.name === "Book A Table" ? handleBookClick : ""} className="is-row">{item.name}</a>
                    )}
                </div>
                <div className="is-col is-3-col is-12-col-mobile is-12-col-tablet footer-links txt-white">
                    <h5>Explore</h5>
                    {footerMenuData?.explore?.map(item =>
                        <a href={item.url} className="is-row" title={item.name}>{item.name}</a>
                    )}   
                </div>
                <div className="is-col is-3-col is-12-col-mobile is-12-col-tablet footer-links txt-white">
                    <h5>Help</h5>
                    {footerMenuData?.help?.map(item =>
                        <a href={item.url} className="is-row">{item.name}</a>
                    )}
                    <a href="javascript:Didomi.preferences.show()" className="is-row" title="Cookie settings">Cookie settings</a>
                </div>
            </div>
        </div>
    );
};

export default withAppState(MenuFooterLinks, {
    mobXProps: ({ activeStep, restaurant, restaurantUrl }) => ({
        activeStep,
        restaurant,
        restaurantUrl
    }),
});